export default __webpack_public_path__ + "static/media/figma.0f4098dc.svg";